import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { ThemeProvider } from '@mui/material/styles'
import React, { ReactNode } from 'react'
import theme from 'theme'

const muiCache = createCache({
  key: 'mui',
  prepend: true,
})

type Props = {
  children: ReactNode
}

function StyleProvider({ children }: Props) {
  return (
    <CacheProvider value={muiCache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  )
}

export default StyleProvider
